const rolePermissionsCss = `
  .role-permissions-table thead tr {
    background: #f8fafc;
    color: #0f172a;
    border-bottom: 1px solid #e2e8f0;
  }
  .role-permissions-table thead th {
    color: #0f172a;
    border-bottom: 1px solid #e2e8f0;
  }
  .role-permissions-table td {
    border-color: #e5e7eb;
  }
  .role-permissions-table tbody tr:hover {
    background: #f8fafc;
  }
  .dark .role-permissions-table thead tr {
    background: #0f172a;
    color: #e2e8f0;
    border-bottom: 1px solid rgba(226, 232, 240, 0.14);
  }
  .dark .role-permissions-table thead th {
    color: #e2e8f0;
  }
  .dark .role-permissions-table td {
    border-color: rgba(55, 65, 81, 0.9);
  }
  .dark .role-permissions-table tbody tr:hover {
    background: rgba(79, 70, 229, 0.08);
  }
`;

export default function RolePermissionsStyles() {
  return <style>{rolePermissionsCss}</style>;
}
